import { useTransition } from 'react-spring';
import flag from './css/Resources/india-flag.png';
import { animated } from 'react-spring';

const About = () => {
    const forward = ['//']

    const transition = useTransition(1, {
        from: { y: 1000, opacity: 0 },
        enter: { y: 0, opacity: 1, delay: 200 },
        leave: {}
    });

    return (
        <div className="About">
            <h1>{forward}ABOUT</h1>
            {
                transition(
                    (style, items) => items ? <animated.div style={style}>
                        <div className="about_container">
                            <div className="about_details">
                                <div className="about_brief">
                                    <span className="colorhigh1">A brief...</span><br />
                                    My name is <span className="colorhigh1">Amreet Kumar Khuntia </span>and as said before I love making
                                    <span className="colorhigh2"> websites</span> and <span className="colorhigh2">experiment</span> with different
                                    <span className="colorhigh2"> technologies</span> to create something new.
                                    I am currently pursuing B.Tech in Electrical Engineering in <span className="colorhigh1">NIT Rourkela</span> situated
                                    in <span className="colorhigh1">INDIA</span>. I am still new to this field so
                                    hoping to learn as much as possible. Building web apps for the betterment of society has been my keen concern
                                    but apart from that I try to focus on <span className="colorhigh2">UI/UX </span>also.
                                </div>
                                <div className="about_things">
                                    <span className="colorhigh1">Things which I do...</span>
                                    <div className="division">
                                        <div className="left">
                                            <div className="colorhigh2">Development:</div>
                                            <div>
                                                While I am facinated by modern websites and
                                                apps <span className="colorhigh1">python</span> modules like <span className="colorhigh1">Open CV</span> etc
                                                fascinate me a lot. Also I would like to learn <span className="colorhigh1">Game Dev</span> some time in near future.
                                            </div>
                                            <div className="colorhigh2">Community Management:</div>
                                            <div>
                                                I don't have much participation in Community Management but recently have been into some clubs from <span className='colorhigh1'>NIT Rourkela</span> like <span className='colorhigh1'>Webwiz, GTA </span>etc.
                                            </div>
                                        </div>
                                        <div className="right">
                                            <div className="colorhigh2">Hackathons:</div>
                                            <div>
                                                I love working in Hackathons. Let it be oraganizing or participating in hackathons both inspire me a lot. I worked as a tech lead in <span className='colorhigh1'>Hackodisha</span>. Also have participated in hackathons such as <span className='colorhigh1'>postman's API Fest</span>  etc.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="about_description">
                                <div>
                                    <span className="colorhigh1">Age:</span> 20<br />
                                    <span className="colorhigh1">Nationality: </span>Indian <img id='indiaflag' src={flag} alt="flag of india"></img><br />
                                    <span className='colorhigh1'>Address: </span>Diha Sahi, Shankarpur,  Cuttack<br />
                                    <span className='colorhigh1'>E-mail: </span><a href='mailto:amreetleo123@gmail.com'>amreetleo123@gmail.com</a><br />
                                </div>
                            </div>
                        </div>
                    </animated.div> : ""
                )
            }

        </div>
    );
}

export default About;